export default __webpack_public_path__ + "static/media/insta3.44350590.svg";